/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocationsSearchByRegionQueryVariables = Types.Exact<{
  bottomRightLat: Types.Scalars['Float']['input'];
  bottomRightLng: Types.Scalars['Float']['input'];
  topLeftLat: Types.Scalars['Float']['input'];
  topLeftLng: Types.Scalars['Float']['input'];
}>;

export type LocationsSearchByRegionQuery = {
  readonly __typename?: 'Query';
  readonly restaurantsByRegion: ReadonlyArray<{
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly slug: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly phone: string;
    readonly isAcceptingOrders: boolean;
    readonly flexMessage: string | null;
    readonly notAcceptingOrdersReason: string;
    readonly sanitaryGradeDisplayText: string | null;
    readonly sanitaryGradeUrl: string | null;
    readonly showOutpostPriceDifferenciationDisclosure: boolean;
    readonly showDeliveryPriceDifferenciationDisclosure: boolean;
    readonly showWarningDialog: boolean | null;
    readonly warningDialogDescription: string | null;
    readonly warningDialogTimeout: number | null;
    readonly warningDialogTitle: string | null;
    readonly hours: {
      readonly __typename: 'RestaurantHours';
      readonly formatted: string | null;
    };
    readonly asset: { readonly __typename: 'Asset'; readonly url: string };
  }>;
};

export const LocationsSearchByRegionDocument = gql`
  query LocationsSearchByRegion(
    $bottomRightLat: Float!
    $bottomRightLng: Float!
    $topLeftLat: Float!
    $topLeftLng: Float!
  ) {
    restaurantsByRegion(
      bottomRightLat: $bottomRightLat
      bottomRightLng: $bottomRightLng
      topLeftLat: $topLeftLat
      topLeftLng: $topLeftLng
    ) {
      __typename
      id
      name
      latitude
      longitude
      slug
      address
      city
      state
      zipCode
      isOutpost
      phone
      isAcceptingOrders
      hours {
        __typename
        formatted
      }
      asset {
        __typename
        url
      }
      flexMessage
      notAcceptingOrdersReason
      sanitaryGradeDisplayText
      sanitaryGradeUrl
      showOutpostPriceDifferenciationDisclosure
      showDeliveryPriceDifferenciationDisclosure
      showWarningDialog
      warningDialogDescription
      warningDialogTimeout
      warningDialogTitle
    }
  }
`;

export function useLocationsSearchByRegionQuery(
  options: Omit<
    Urql.UseQueryArgs<LocationsSearchByRegionQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LocationsSearchByRegionQuery,
    LocationsSearchByRegionQueryVariables
  >({ query: LocationsSearchByRegionDocument, ...options });
}
